// src/components/viewer/NoComponentsVisibleSearchBanner.tsx
import React from "react";
import { ActionIcon, Alert, Group, Text } from "@mantine/core";
import { FaInfoCircle } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { selectShouldWarnNoComponentsVisibleForComponentSearch } from "./ViewerRedux/viewerSelectors";
import { clearFreeTextSearchInRedux } from "./ViewerRedux/viewerSlice";

export const NoComponentsVisibleSearchBanner: React.FC = () => {
  const dispatch = useAppDispatch();

  const shouldShow = useAppSelector(selectShouldWarnNoComponentsVisibleForComponentSearch);

  if (!shouldShow) return null;

  return (
    <Alert
      variant="light"
      color="orange"
      radius="xl"
      icon={<FaInfoCircle size={16} />}
      styles={{
        root: {
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 14,
          paddingRight: 10,
          backgroundColor: "var(--mantine-color-orange-1)",
          border: "1px solid var(--mantine-color-orange-4)",
          boxShadow: "0 4px 18px rgba(0,0,0,0.18)",
        },
      }}
    >
      <Group justify="space-between" align="center" wrap="nowrap">
        <div>
          <Text size="sm" fw={600} c="black">
            Ingen komponenter er synlige
          </Text>
          <Text size="xs" c="dimmed">
            Du søker på komponenter, men ingen komponenter er slått på i visningen. Skru på filter
            (IFC-klasse / fag) for å få treff.
          </Text>
        </div>

        <ActionIcon
          variant="subtle"
          color="orange"
          radius="xl"
          aria-label="Tøm søk"
          onClick={() => dispatch(clearFreeTextSearchInRedux())}
        >
          <FaXmark size={14} />
        </ActionIcon>
      </Group>
    </Alert>
  );
};
